import React from 'react'
import gifImage from '../../Assets/Error/Animation.gif'
import lottieJson from '../../Assets/Json/Lottie.json'
import Lottie from "lottie-react";
import { Button, ConfigProvider } from 'antd';
import {
  FilterOutlined,
   } from "@ant-design/icons";
import { useSelector } from 'react-redux';
 
const Empty = ({open,setOpen,isdarkMode}) => {
  const color = useSelector((state) => state.ThemeChange);
  // console.log(color)
  return (
    <div className="flex flex-col items-center m-0 justify-center h-[80vh] w-[100%] overflow-hidden rounded-xl" 
    // style={{ backgroundColor: color.themeConfig.colorPrimaryShade }}
    >
    {/* <img src={gifImage} alt="Animated GIF" width="300" /> */}
    <div className=' flex justify-center items-center flex-col gap-2'>
    
            <Lottie className='w-[300px] h-[300px] overflow-hidden' animationData={lottieJson} loop={true} autoplay={true}  />
      
      <div className={`${isdarkMode? 'text-white': 'text-black'} font-[Poppins] text-[16px]`}>
        Click <span  className='font-bold'>
          "Filter Button"
          </span>   
           below to filter and get the desired data
      </div>

               <Button type="primary" size="large" className="flex justify-center items-center " onClick={()=>setOpen(!open)}>
               <FilterOutlined /> Filter
               </Button>
    </div>
  </div>
  ) 
}

export default Empty


// import React from "react";
// import { ConfigProvider, DatePicker } from "antd";
// import dayjs from "dayjs";
// import "dayjs/locale/en";
// import locale from "antd/es/locale/en_US";

// const themeConfig = {
//   token: {
//     colorPrimary: "#ff4d4f", // Red primary color
//     colorBorder: "#ff7875", // Light red border
//     colorBgContainer: "#fff1f0", // Light red background
//     colorText: "#a8071a", // Dark red text
//   },
// };

// const Empty = () => {
//   return (
//     <ConfigProvider locale={locale} theme={themeConfig}>
//       <div style={{ padding: 20, backgroundColor: "#fff1f0", minHeight: "100vh" }}>
//         <h2 style={{ color: "#a8071a" }}>Red Themed DatePicker</h2>
//         <DatePicker style={{ borderColor: "#ff7875", color: "#a8071a", marginRight: 10 }} />
//         <TimePicker style={{ borderColor: "#ff7875", color: "#a8071a" }} />      </div>
//     </ConfigProvider>
//   );
// };

// export default Empty;
